import { useSite } from "@/context/SiteContext";
import { Reveal } from "@/components/Reveal";

export default function About() {
  const { t } = useSite();

  return (
    <section id="about" className="relative py-24 md:py-36 bg-[hsl(var(--muted))]/40 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Founder card (photo added later) */}
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative rounded-md border border-border bg-[hsl(var(--card))] p-10 md:p-12 overflow-hidden" data-testid="about-badge">
                <div className="absolute -top-8 -right-8 h-28 w-28 rounded-full bg-ibk/10" />
                <div className="absolute top-0 left-0 h-1.5 w-24 bg-ibk" />
                <span className="block font-serif font-extrabold text-[7rem] leading-none text-ibk/15 select-none">NK</span>
                <div className="relative mt-6">
                  <span className="block font-serif text-4xl font-bold text-foreground">{t.about.name}</span>
                  <span className="block text-xs uppercase tracking-[0.28em] mt-2 text-ibk font-bold">{t.about.role}</span>
                </div>
                <p className="relative mt-8 border-t border-border pt-6 text-lg italic text-muted-foreground">
                  „Fair. Ehrlich. Zuverlässig."
                </p>
              </div>
            </Reveal>
          </div>

          {/* Text */}
          <div className="lg:col-span-7 lg:pl-8">
            <Reveal>
              <div className="flex items-center gap-3 mb-4">
                <span className="h-px w-10 bg-ibk" />
                <span className="text-xs font-bold uppercase tracking-[0.3em] text-ibk">{t.about.label}</span>
              </div>
              <h2 className="font-serif font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-foreground leading-[1.05]">
                {t.about.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg text-muted-foreground leading-relaxed max-w-2xl">{t.about.p1}</p>
              <p className="mt-4 text-lg text-muted-foreground leading-relaxed max-w-2xl">{t.about.p2}</p>
            </Reveal>

            <div className="mt-12 grid sm:grid-cols-3 gap-8">
              {t.about.values.map((v, i) => (
                <Reveal key={i} delay={0.15 + i * 0.08}>
                  <div data-testid={`value-${i}`} className="border-t border-border pt-4">
                    <span className="font-mono text-xs text-ibk">0{i + 1}</span>
                    <h3 className="font-serif font-bold text-2xl text-foreground mt-1">{v.t}</h3>
                    <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{v.d}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
